import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Admins from '../Admins/Admins';

export default function AlertDialog(props) {
  const handleNo = () => {
    props.setOpen(false);
    props.yes(false)
  };
  const handleYes = () => {
    props.setOpen(false);
   return props.yes(true)
   
  };

  return (
    <div>
      <Dialog
        open={props.open}
        onClose={handleNo}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
         Alert!
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
          {props.mess}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleNo}>No</Button>
          <Button onClick={handleYes} autoFocus>
            Yes
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
